import { Toast } from '@fastfive-dev/fastfive-design-system/components';

const TOAST_SELECTOR = '.Toastify__toast';
const RETRY_INTERVAL_MS = 100;
const RETRY_TIMEOUT_MS = 5_000;

type ToastVariant = 'success' | 'error' | 'warning' | 'information';

/**
 * 토스트가 실제로 뜰 때까지 재발사한다.
 *
 * `Toast.*` 는 전용 containerId 로 발사되는데, 그 컨테이너가 아직 스토어에 등록되기 전이면
 * 호출이 조용히 버려진다. **첫 페인트 직후 호출되는 곳만** 이 경합에 걸린다
 * (사용자 조작 시점의 호출부는 이미 등록이 끝나 있어 `Toast.*` 를 그대로 쓰면 된다).
 *
 * 마운트 순서 조정(컨테이너 뒤에 렌더)과 macrotask 지연(setTimeout 0) 은 실측에서 모두 실패했고,
 * 100ms 지연만 성공했다. 등록 시점이 dev(MSW 게이트)/prod 마다 달라 고정 지연은 신뢰할 수 없다.
 * 컨테이너는 토스트가 하나도 없으면 DOM 에 아무것도 렌더하지 않아 준비 여부를 밖에서 알 수도 없다.
 * 버려진 호출은 아무 일도 일어나지 않으므로, 토스트 DOM 이 보일 때까지 재시도하는 편이 안전하다.
 *
 * 컨테이너는 `AppProviders` 에 있어 클라이언트 라우팅으로 언마운트되지 않는다 —
 * 발사 직후 `router.replace` 로 화면을 옮겨도 토스트는 그대로 남는다.
 */
export function showToastWithRetry(
  message: string,
  variant: ToastVariant = 'success',
): void {
  Toast[variant](message);
  if (document.querySelector(TOAST_SELECTOR)) return;

  const startedAt = Date.now();
  const timer = setInterval(() => {
    if (
      document.querySelector(TOAST_SELECTOR) ||
      Date.now() - startedAt > RETRY_TIMEOUT_MS
    ) {
      clearInterval(timer);
      return;
    }
    Toast[variant](message);
  }, RETRY_INTERVAL_MS);
}
